import { useTheme } from "@mui/styles";
import React from "react";

function VerticalDivider() {
  const theme = useTheme();
  return (
    <div
      style={{
        borderLeft: `${theme.size[1]} solid ${theme.palette.grey[1]}`,
        height: theme.size[20],
      }}
    ></div>
  );
}

export default VerticalDivider;
